"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringType = 'string';
exports.BooleanType = 'boolean';
exports.NumberType = 'number';
exports.DurationType = 'duration';
function durationAsSeconds(duration) {
    return duration.seconds + duration.minutes * 60 + duration.hours * 60 * 60;
}
exports.durationAsSeconds = durationAsSeconds;
function secondsAsDuration(inputSeconds) {
    const seconds = inputSeconds % 60;
    const minutes = Math.floor((inputSeconds - seconds) / 60) % 60;
    const hours = Math.floor((inputSeconds - minutes * 60 - seconds) / 3600);
    return {
        hours,
        minutes,
        seconds
    };
}
exports.secondsAsDuration = secondsAsDuration;
function duration(hours, minutes, seconds) {
    return { hours, minutes, seconds };
}
exports.duration = duration;
//# sourceMappingURL=type.js.map